/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import { motion } from 'framer-motion';
import React,{useState,useContext,useCallback,useEffect} from 'react'
import HeaderContext from '../../Components/Context/HeaderContext';
import ThreeDotsLoader from '../../Components/LoadingDots'
import { ValidateEmail } from '../../redux/helper/validateEmail';
import { distributorService } from '../../service/distributor.service';

function CrudModal({setopen,open, isUpdate, handleFetch,editData,setEditData,handleError}) {
    const {
        SetSuccessMessage,
        setcolorValue,
    } = useContext(HeaderContext);
    const [state, setstate] = useState({
        first_name:'',
        last_name: '',
        email: '',
        phone_number: '',
        status: false
    });
    const [submitSelected, setsubmitSelected] = useState(false);
    const [loading, setloading] = useState(false);
    const except=['first_name','last_name']
    const InputChange = (e, index) => {
        e.preventDefault();
        const { id, value } = e.target;
        setstate((prevState) => ({
            ...prevState,
            [id]: except.includes(id) ?value.replace(/[^a-z]/gi, ''):value,
        }));
    };
    const validate = () => {
        let isvalid = true;
        Object.keys(state).forEach((key) => {
            switch (key) {
            case 'first_name':
            case 'email':
            case 'phone_number':
                if (state[key] === '') {
                    isvalid = false;
                }
                break;
            default: break;
            }
        });
        return isvalid;
    };
    const updatePayload = () => {
        let payloadbody={}
        let isvalid = true;
        Object.keys(state).forEach((key) => {
            switch (key) {
            case 'first_name':
            case 'last_name':
            case 'email':
            case 'phone_number':
                if(state[key] !== editData[key]) {
                    payloadbody[key] = state[key]
                }
                break;
            case 'status':
                const val = state.status?"1":"0";
                if(val!== editData.user_status);
                payloadbody['user_status'] = val;

            default: break;
            }
        });
        return payloadbody;
    };
    
    const handleUpdateValue =  useCallback(
        () => {
            setstate({
                first_name:editData.first_name,
                last_name: editData.last_name,
                email: editData.email,
                phone_number: editData.phone_number,
                status: editData.user_status === '0' ? false : true}
            )
        },
        [],
    )
    
    useEffect(() => {
        if(isUpdate){
            handleUpdateValue()
        }
    }, [handleUpdateValue])
    
    const handleCreateUser = async (e) => {
        e.preventDefault();
        setloading(true);
        setsubmitSelected(true);
        if (!validate()) {
            setloading(false);
            return;
        }
        const {ACCOUNT_NUMBER} = JSON.parse(localStorage.getItem('user')).profile;
        if (!ValidateEmail(state.email)) {
            handleError('Invalid Email Address');
            return;
        }
        if (state.phone_number.length < 10) {
            handleError('Mobile number should be 10 digit number');
            return;
        }
        const payload = {
            "first_name":state.first_name,
            "last_name":state.last_name,
            "email":state.email,
            "phone_number":state.phone_number,
            "distributor_id":ACCOUNT_NUMBER,
            "user_status":String(state.status?"1":'0')};
        let create;
        if (isUpdate) {
            const newayload = updatePayload()
            create = await distributorService.UpdateAssistantUsers(newayload,editData.user_id,ACCOUNT_NUMBER);
        } else {
            create = await distributorService.CreateAssistantUser(payload);
        }
        if (!create?.error && create.data.success_status) {
            const update='Changes have been saved successfully!'
            SetSuccessMessage(isUpdate ?update:`User has been added successfully!`);
            setTimeout(() => {
                SetSuccessMessage('');
                setcolorValue(false);
                setloading(false);
                setopen(false);   
                handleFetch();        
            }, 1000);
        } else {
            handleError(create.message.response.data.message)
        }
    };
    return (
        <div className={`modal fade fixed top-0 right-0 md:px-0 px-5 md:py-0 py-2.5 w-full h-full outline-none overflow-x-hidden overflow-y-auto ${open?'show':'hidden'}`} id="addAssistantUser" tabIndex="-1" aria-labelledby="addAdminUser" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered relative md:max-w-[620px] max-w-full pointer-events-none ml-auto mt-0 mr-0 mb-0 h-full shadow-4xl bg-[#ffffff]">
                <div className="modal-content border-none relative flex flex-col w-full pointer-events-auto bg-clip-padding outline-none text-current h-full">
                    <img className="p-2 rounded-full cursor-pointer absolute top-10 right-[30px]" 
                        onClick={()=>{
                            setopen(false);
                            setEditData({})
                        }}
                        src="images/close.svg" alt="close-icon" data-bs-dismiss="modal" aria-label="Close" />
                    <div className="mt-8 sm:px-[30px] px-[0px] bg-[##FFFFFF]">
                        <div className="mx-8 bg-[#FFFFFF]">
                            <h2 className="text-xl font-semibold text-[#555259] flex items-center mt-[38px]">
                                {isUpdate?'Update':'Add'} Assistant User
                            </h2>
                            <form onSubmit={(e)=>handleCreateUser(e)} className="">
                                <div className="flex sm:flex-nowrap flex-wrap -mx-4 mt-5">
                                    <div className="sm:w-1/2 w-full sm:px-4 px-1">
                                        <div>
                                            <label htmlFor="first_name" className="text-sm font-normal text-[#555259] bg-[#FFFFFF]">First Name <span className="text-[#F72C1D]">*</span></label>
                                            <input 
                                                onChange={(e)=>InputChange(e)}
                                                onFocus={()=>setsubmitSelected(false)}
                                                id="first_name"
                                                value={state.first_name}
                                                type="text" className="field h-12 mt-[6px] outline-0 border border-[#555259] bg-[#FFFFFF] w-full rounded-lg text-base font-semibold text-[#090406] px-4 placeholder:text-sm placeholder:font-normal placeholder:text-[#A5A5A5]" placeholder="Enter First Name" />
                                        </div>
                                        {submitSelected && state.first_name === '' && <p className="text-[#ED1C24] font-normal text-sm error-msg mt-2">Please enter first name</p>}
                                    </div>
                                    <div className="sm:w-1/2 w-full sm:px-4 px-2 sm:mt-0 mt-4">
                                        <div>
                                            <label htmlFor="last_name" className="text-sm font-normal text-[#555259] bg-[#FFFFFF]">Last Name</label>
                                            <input id="last_name" 
                                                value={state.last_name}
                                                onChange={(e)=>InputChange(e)}
                                                onFocus={()=>setsubmitSelected(false)}
                                                type="text" className="h-12 mt-[6px] outline-0 border border-[#555259] bg-[#FFFFFF] w-full rounded-lg text-base font-semibold text-[#090406] px-4 placeholder:text-sm placeholder:font-normal placeholder:text-[#A5A5A5]" placeholder="Enter Last Name" />
                                        </div>
                                    </div>
                                </div>
                                <div className="flex sm:flex-nowrap flex-wrap -mx-4 sm:mt-8 mt-4">
                                    <div className="sm:w-1/2 w-full sm:px-4 px-2">
                                        <div>
                                            <label htmlFor="email" className="text-sm font-normal text-[#555259] bg-[#FFFFFF]">Email Address <span className="text-[#F72C1D]">*</span></label>
                                            <input 
                                                value={state.email}
                                                onChange={(e)=>InputChange(e)}
                                                onFocus={()=>setsubmitSelected(false)}
                                                type="email" className="field1 h-12 mt-[6px] outline-0 border border-[#555259] bg-[#FFFFFF] w-full rounded-lg text-base font-semibold text-[#090406] px-4 placeholder:text-sm placeholder:font-normal placeholder:text-[#A5A5A5]" placeholder="Enter Email Address" id="email" />
                                        </div>
                                        {submitSelected && state.email === '' && <p className="text-[#ED1C24] font-normal text-sm error-msg1 mt-2  w-full">Please enter valid email address</p>}
                                    </div>
                                    <div className="sm:w-1/2 w-full sm:px-4 px-2 sm:mt-0 mt-4">
                                        <div>
                                            <label htmlFor="phone_number" className="text-sm font-normal text-[#555259] bg-[#FFFFFF]">Mobile Number <span className="text-[#F72C1D]">*</span></label>
                                            <input type="number" id="phone_number"
                                                value={state.phone_number}
                                                maxLength="10"
                                                onChange={(e)=>{
                                                    if(e.target.value.length <= 10){
                                                        InputChange(e)
                                                    }
                                                }}
                                                onFocus={()=>setsubmitSelected(false)}
                                                className="field2 h-12 mt-[6px] outline-0 border border-[#555259] bg-[#FFFFFF] w-full rounded-lg text-base font-semibold text-[#090406] px-4 placeholder:text-sm placeholder:font-normal placeholder:text-[#A5A5A5]"
                                                placeholder="Enter Mobile Number" />
                                        </div>
                                        {submitSelected && state.phone_number === '' && <p className="text-[#ED1C24] font-normal text-sm error-msg2 mt-2 w-full">Please enter valid mobile number</p>}
                                    </div>
                                </div>
                                <div className="flex justify-between">
                                </div> 
                                <p className="selected-role text-sm font-normal text-[#555259] mt-8">Status:</p>
                                <div className="status custom-toggle1 flex justify-start items-center relative">
                                    <label className="switch">
                                        <input type="checkbox" checked={state.status} onChange={
                                            ()=>
                                                setstate((prevState) => ({
                                                    ...prevState,
                                                    status:!state.status
                                                }))
                                        } className='hidden'/><span className="slider round"></span></label><span className="selected-role textsm font-normal text-[#A5A5A5]" style={{marginLeft:'6px'}}>{state.status ? 'Active':'Inactive'}</span>
                                </div>
                                
                                <div className="flex justify-center md:mt-[78px] mt-[20px] success-msg">
                                    <button type="submit" className="rounded-lg bg-[#555259] w-[270px] h-[53px] text-lg font-semibold text-[#FFFFFF] text-center msg4 flex justify-center items-center" data-bs-dismiss="modal" aria-label="Close">
                                        {loading ? <ThreeDotsLoader/> : isUpdate ? 'Update User' : 'Add User'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default CrudModal;